import { IObjectTranslatable, RelationalActionExtractor, RelationalActionTranslator, HtmlColorCodeTranslator } from ".";
import { ICircleSelectItemBean, ITypeDefinable, BeanTypes } from "../beans/items";
import { IItem, CircleSelectItem } from "../../../../domain/document/items";
import { HisItemParameterTranslator } from "../../../his/ver2/HisItemParameterTranslator";
import { Point, Size, Rectangle, LineStyle, Color } from "../../../../domain/drawing";

export class CircleSelectItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as ICircleSelectItemBean;
    const result = new CircleSelectItem(bean.selected, bean.checkedScore, bean.defaultScore);
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.name = bean.name;
    result.groupKey = bean.groupKey;
    result.actions = RelationalActionTranslator.toItems(bean.relationalItems);
    result.shouldQuote = !!bean.isQuotable;
    result.supportedQuotable = !!bean.supportedQuotable;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.isMultiCheckable = bean.isMultiSelect;
    result.enableNameGroupEmptyCheck = bean.nameGroupEmptyCheck;
    result.enableEmptyCheckConfirmation = bean.isEmptyCheckIgnorable;
    result.lineStyle = new LineStyle(new Color(bean.lineColor), bean.lineStyle, bean.lineWidth);
    result.text = bean.text;
    result.patientProfileOption = bean.patientProfileOption;
    result.itemName = bean.itemName;
    result.groupName = bean.itemName; // 円選択の分類名がグループ名称になる
    result.isHisInfo = bean.isHisInfo;
    result.displayName = bean.displayName;
    result.toolTip = bean.toolTip;
    result.hisItemParameter = HisItemParameterTranslator.toHisItemParameter(bean.hisItemParameter);
    result.scriptExecuteParameters = RelationalActionExtractor.extractScriptExecuteParameters(result.actions);
    result.isDialogMultiSelectable = !!bean.enabledHisMultiSelect;
    result.isNaturalViewEnable = bean.naturalView;
    result.naturalText = bean.naturalText;
    result.pasteDestinations = RelationalActionExtractor.extractTextPasteParameters(result.actions);
    result.parentAlertInformations = RelationalActionExtractor.extractParentAlertParameters(result.actions);
    result.isFreeInputable = bean.supportedFreeText;
    result.shouldInputFree = bean.enabledFreeText;
    result.shouldLinkAsWideScope = !!bean.isWideScope;
    result.dacsProcessType = bean.dacsProcessType;
    result.dacsItemName = bean.dacsItemName;
    result.dacsItemCode = bean.dacsItemCode;
    return result;
  }

  toBean(item: IItem): ITypeDefinable {
    const target = item as CircleSelectItem;
    const bean: ICircleSelectItemBean = {
      type: BeanTypes.CircleSelect,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      name: target.name,
      groupKey: target.groupKey,
      isVisible: target.isVisible,
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      x: target.geometry.rectangle.x,
      y: target.geometry.rectangle.y,
      width: target.geometry.rectangle.width,
      height: target.geometry.rectangle.height,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      isMultiSelect: target.isMultiCheckable,
      checkedScore: target.checkedValue,
      defaultScore: target.uncheckedValue,
      lineColor: HtmlColorCodeTranslator.fromColor(target.lineStyle.color),
      lineStyle: target.lineStyle.kind,
      lineWidth: target.lineStyle.width,
      selected: target.isChecked,
      relationalItems: null,  // TODO:返却する必要ある？
      nameGroupEmptyCheck: target.enableNameGroupEmptyCheck,
      isEmptyCheckIgnorable: target.enableEmptyCheckConfirmation,
      text: target.text,
      patientProfileOption: target.patientProfileOption,
      itemName: target.itemName,
      isHisInfo: target.isHisInfo,
      displayName: target.displayName,
      toolTip: target.toolTip,
      isQuotable: target.shouldQuote,
      supportedQuotable: target.supportedQuotable,
      hisItemParameter: null, // 返却する必要なし
      naturalView: target.isNaturalViewEnable,
      naturalText: target.naturalText,
      supportedFreeText: target.isFreeInputable,
      enabledFreeText: target.shouldInputFree,
      enabledHisMultiSelect: target.isDialogMultiSelectable,
      isWideScope: target.shouldLinkAsWideScope,
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
      dacsProcessType: target.dacsProcessType,
      dacsItemName: target.dacsItemName,
      dacsItemCode: target.dacsItemCode,
    };
    return bean;
  }
}
